export default function MatchingHeaders() {
  return <div className='grid grid-cols-7 ml-[24px] text-[15px] font-medium leading-[20px] mb-[10px] secondary-font mr-[170px]'>
    <p className='col-span-2 truncate'>Product name</p>
    <p className='truncate'>Weight</p>
    <p className='truncate'>Category</p>
    <p className='truncate '>Confidence</p>
    <p className='truncate'>Carbon Footprint</p>
  </div>;
}